export function buildMarketsBannerKey(headerUrl, headerId) {
  if (headerUrl == null) return headerId === 0 ? 'MarketsBanner' : null;
  if (typeof headerUrl !== 'string') return null;
  if (!headerUrl.trim()) return headerId === 0 ? 'MarketsBanner' : null;
  const categoryKey = headerUrl.replace(/[^a-zA-Z0-9]/g, '');
  return categoryKey ? `Markets${categoryKey}Banner` : null;
}

export function buildMarketBonusKey(marketId) {
  if (typeof marketId !== 'number' && !(typeof marketId === 'string' && /^\d+$/.test(marketId))) {
    return null;
  }
  const id = Number(marketId);
  return Number.isSafeInteger(id) && id > 0 ? `MarketDetail${id}BonusPanel` : null;
}

export function hasStaticPageContent(data) {
  if (typeof data?.renderedHTML !== 'string' || !data.renderedHTML.trim()) return false;

  const template = document.createElement('template');
  template.innerHTML = data.renderedHTML;
  const content = template.content;
  content
    .querySelectorAll('style, script, template, noscript, [hidden]')
    .forEach((el) => el.remove());
  content.querySelectorAll('[style]').forEach((el) => {
    if (el.style.display === 'none' || el.style.visibility === 'hidden') el.remove();
  });
  if (content.textContent.replace(/[\s\u200B-\u200D\uFEFF]/g, '')) return true;

  return !!content.querySelector(
    [
      'img[src]',
      'img[srcset]',
      'picture source[srcset]',
      'video',
      'audio',
      'iframe[src]',
      'svg',
      'canvas',
      'object[data]',
      'embed[src]',
      'input:not([type="hidden"])',
      'button',
      '.predictit__videowidget',
      '.predictit__markettilelist',
      '.predictit__marketpreview',
      '.predictit__headtoheadmarkettileset',
      '.predictit__datachart',
      '.predictit__docswidget',
      '.predictit__mapwidget',
      '.predictit__carousel',
      '.predictit__podcastslider',
      '.predictit__accordion',
      '.predictit__twitter',
      '.predictit__elapsedtime',
      '.predictit-login-control',
    ].join(', '),
  );
}

// Create once per app lifetime. Keep payloads/promises only, never DOM or persistent storage.
export function createOptionalStaticPageLoader(fetchPage) {
  const resolved = new Map();
  const pending = new Map();

  return (key) => {
    if (typeof key !== 'string' || !key.trim()) return Promise.resolve(null);
    if (resolved.has(key)) return Promise.resolve(resolved.get(key));
    if (pending.has(key)) return pending.get(key);

    const request = Promise.resolve()
      .then(() => fetchPage(key))
      .then((data) => {
        const payload = hasStaticPageContent(data) ? data : null;
        resolved.set(key, payload);
        return payload;
      })
      .catch((error) => {
        const status = error?.response?.status;
        if (status !== 400 && status !== 404) throw error;
        resolved.set(key, null);
        return null;
      })
      .finally(() => pending.delete(key));

    pending.set(key, request);
    return request;
  };
}
